









import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import Nav from '@/components/Nav.vue';
@Component({
    components: {Nav}
})
export default class Layout extends Vue {
    @Prop(String) classPrefix?: string;
}
